import { defaultSvgProps, SvgProps } from "../type/props";

export const BellIcon = (props?: SvgProps) => {
  const { width, height, fill, stroke, style } = defaultSvgProps(props, {
    width: 16,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <path d="M10.268 21a2 2 0 0 0 3.464 0" />
      <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
    </svg>
  );
};
